//src/components/SearchDropDown.jsx
import React, { useState } from "react";
import {
  TextField,
  Autocomplete,
  Box,
  IconButton,
  useTheme,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { tokens } from "../theme";

const resolvePatientType = (patient) =>
  patient?.patientType || patient?.patient_type || "";

const formatPatientTypeLabel = (patientType) => {
  if (patientType === "OUT") return "OUT Patient";
  if (patientType === "IN") return "IN Patient";
  return "";
};

const SearchDropDown = ({
  placeholder,
  data,
  onPatientSelect,
  size = "small",
  sx = {},
}) => {
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleSelect = (patient) => {
    onPatientSelect(patient);
    setInputValue("");
  };

  const getPatientOptionLabel = (option) => {
    const parts = [
      option.id || "",
      option.name || "",
      option?.age != null ? `${option.age} yrs` : "",
      option.mobile ? `Ph ${option.mobile}` : "",
      formatPatientTypeLabel(resolvePatientType(option)),
    ].filter(Boolean);
    return parts.join(" : ");
  };

  return (
    <Autocomplete
      size={size}
      sx={{ backgroundColor: `${colors.primary[400]}`, width: "100%", ...sx }}
      getOptionLabel={getPatientOptionLabel}
      value={value}
      options={data}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      onChange={(event, newValue) => {
        handleSelect(newValue);
        setInputValue("");
        setValue(null);
      }}
      noOptionsText="Patient not found"
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`${placeholder}`}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchDropDown;
